import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'
import { HeaderButton } from './header-button'

type Props = {
  resultCount: number
  downloadLimit: number
  isLoading: boolean
  allowed: boolean
  enterprise: boolean
  restricted: boolean
  onClick: () => any
}

export const DownloadButton: React.FC<Props> = ({
  resultCount,
  downloadLimit,
  isLoading,
  allowed,
  enterprise,
  restricted,
  onClick,
}) => {
  const zero = resultCount === 0
  const over = resultCount > downloadLimit

  const tooltipText = !enterprise
    ? 'こちらの機能は本契約ユーザの方のみ利用可能となっています'
    : !allowed
      ? 'こちらの機能は現在のプランではご利用いただけません。お問い合わせ: https://initial.inc/contact'
      : restricted
        ? '大量のダウンロードが検出されたので、機能を制限しております。お問い合わせ: https://initial.inc/contact'
        : over
          ? `先頭${downloadLimit}件のみダウンロードされます`
          : zero
            ? '検索結果が0件の場合はダウンロードできません'
            : undefined

  return (
    <HeaderButton
      disabled={!enterprise || !allowed || zero || restricted}
      isLoading={isLoading}
      tooltip={tooltipText}
      label={'ダウンロード'}
      onClick={() => onClick()}
    >
      <IcomoonIcon
        name="download"
        css={css`
          padding-right: 4px;
          vertical-align: middle;
          font-size: 20px;
          color: ${colors.black10};
        `}
      />
    </HeaderButton>
  )
}
